/* eslint-disable no-nested-ternary */
import styled from 'styled-components'

import { ProgressBarProps, useFont } from '@confer/lib'
import { getColours } from '@confer/lib/utils'
import { Banner } from './Banner'
import { GridLayoutProps } from './Interfaces'
import { Logos } from './Logos'

const DesktopGridLayout = (props: GridLayoutProps) => {
  const { settings, question, children } = props
  const { logoSettings, leftBanner, rightBanner, backgroundImage, progressBar } = settings

  const { backgroundColour } = getColours(settings)

  const fontFamily = useFont()

  const logosProps =
    question.hideLogo && logoSettings
      ? {
          ...logoSettings,
          hide: question.hideLogo,
        }
      : logoSettings

  const progressProps: ProgressBarProps = {
    percentage: props.currentPercentage,
    settings,
    hide: !progressBar,
  }

  return (
    <Container fontFamily={fontFamily}>
      {leftBanner ? <Banner userProps={leftBanner} progressBarProps={progressProps} /> : undefined}
      <Content background={backgroundImage} backgroundColour={backgroundColour}>
        <Header>
          {logosProps ? <Logos {...logosProps} /> : undefined}
          {question.section ? (
            <Section colour={question.section.colour}>{question.section.name}</Section>
          ) : undefined}
        </Header>
        {children}
      </Content>
      {rightBanner ? (
        <Banner userProps={rightBanner} progressBarProps={progressProps} />
      ) : undefined}
    </Container>
  )
}

interface ContainerProps {
  fontFamily: string
}

const Container = styled.div<ContainerProps>`
  display: flex;
  width: 100vw;
  height: 100vh;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
  margin: 0;
  font-family: ${(props) => props.fontFamily};
`

interface ContentProps {
  background?: string
  backgroundColour: string
}

const Content = styled.div<ContentProps>`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  align-items: stretch;
  margin: 0;
  background-image: ${(props) => (props.background ? `url(${props.background})` : 'none')};
  background: ${(props) => props.backgroundColour};
`
const Header = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: auto;
`

interface SectionProps {
  colour?: string
}

const Section = styled.div<SectionProps>`
  padding-left: 1rem;
  font-size: 1.1rem;
  // color: ${(props) => props.colour || 'black'};
  // font-weight: 600;
  &::after {
    content: '';
    position: relative;
    width: 100%;
    height: 1.5px;
    left: 0;
    display: block;
    clear: both;
    // background-color: rgba(0, 0, 0, 0.5)
    background-color: ${(props) => props.colour || 'rgba(0, 0, 0, 0.5)'};
  }
`

export default DesktopGridLayout
